import { motion } from "framer-motion";
import { Mail, Linkedin, MessageSquare, ArrowUpRight } from "lucide-react";

const EMAIL = "joneten91@gmail.com";
const LINKEDIN = "https://www.linkedin.com/in/joneten-saputra-913816105/";

const Contact = () => {
  return (
    <section id="contact" data-testid="contact-section" className="relative py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 grid-bg-fine opacity-30 pointer-events-none" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-blue-500/10 rounded-full blur-[140px] pointer-events-none" />

      <div className="relative max-w-5xl mx-auto px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
        >
          <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-blue-400 font-mono-display">
            <span className="w-1.5 h-1.5 rounded-full bg-blue-400 animate-pulse" />
            /// Contact
          </div>
          <h2
            className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-white"
            style={{ fontFamily: "Outfit" }}
            data-testid="contact-title"
          >
            Let's build practical, scalable, and{" "}
            <span className="text-gradient-aurora">impactful technology solutions.</span>
          </h2>
          <p className="mt-5 text-base text-slate-400 leading-relaxed max-w-2xl mx-auto">
            Tertarik berdiskusi tentang produk, solusi teknis, atau kolaborasi project? Hubungi
            melalui email atau LinkedIn — saya akan merespons sesegera mungkin.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mt-12 grid sm:grid-cols-2 gap-5"
        >
          <a
            href={`mailto:${EMAIL}`}
            data-testid="contact-email"
            className="group relative rounded-2xl p-7 glass-elevated corners scanline-hover hover:-translate-y-0.5 transition-all duration-300 text-left overflow-hidden"
          >
            <div className="flex items-center justify-between">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500/20 to-indigo-500/10 border border-blue-400/30 grid place-items-center group-hover:shadow-[0_0_28px_rgba(59,130,246,0.45)] transition-shadow">
                <Mail className="w-5 h-5 text-blue-200" strokeWidth={1.5} />
              </div>
              <ArrowUpRight className="w-5 h-5 text-slate-400 group-hover:text-blue-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
            </div>
            <div className="mt-5 text-[11px] uppercase tracking-[0.22em] text-blue-400 font-mono-display">
              email
            </div>
            <div className="mt-1 text-lg text-white font-medium" style={{ fontFamily: "Outfit" }}>
              {EMAIL}
            </div>
            <p className="mt-2 text-sm text-slate-400">
              Diskusikan project, kolaborasi, atau konsultasi teknologi melalui email.
            </p>
          </a>

          <a
            href={LINKEDIN}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-linkedin"
            className="group relative rounded-2xl p-7 glass-elevated corners scanline-hover hover:-translate-y-0.5 transition-all duration-300 text-left overflow-hidden"
          >
            <div className="flex items-center justify-between">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-cyan-500/20 to-blue-500/10 border border-cyan-400/30 grid place-items-center group-hover:shadow-[0_0_28px_rgba(34,211,238,0.45)] transition-shadow">
                <Linkedin className="w-5 h-5 text-cyan-200" strokeWidth={1.5} />
              </div>
              <ArrowUpRight className="w-5 h-5 text-slate-400 group-hover:text-cyan-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
            </div>
            <div className="mt-5 text-[11px] uppercase tracking-[0.22em] text-cyan-300 font-mono-display">
              linkedin
            </div>
            <div className="mt-1 text-lg text-white font-medium" style={{ fontFamily: "Outfit" }}>
              /in/joneten-saputra-913816105
            </div>
            <p className="mt-2 text-sm text-slate-400">
              Terhubung secara profesional dan ikuti perjalanan Joneten di LinkedIn.
            </p>
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-10"
        >
          <a
            href={`mailto:${EMAIL}?subject=Konsultasi%20Project%20Teknologi`}
            data-testid="contact-consult-cta"
            className="group relative inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-medium shadow-[0_0_30px_rgba(59,130,246,0.4)] hover:shadow-[0_0_60px_rgba(59,130,246,0.7)] transition-shadow duration-300 overflow-hidden"
          >
            <span className="absolute inset-0 bg-gradient-to-r from-cyan-400/0 via-cyan-300/25 to-cyan-400/0 -translate-x-full group-hover:translate-x-full transition-transform duration-700" />
            <MessageSquare className="w-4 h-4" strokeWidth={1.75} />
            Konsultasi Project
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
